export const formatNumber = (value?: Nullable<number>): string => (value || 0).toLocaleString();

export const formatDate = (isoDateTime?: Nullable<string>): string =>
  isoDateTime ? new Date(isoDateTime).toLocaleDateString() : '';

export const formatTime = (isoDateTime?: Nullable<string>): string =>
  isoDateTime ? new Date(isoDateTime).toLocaleTimeString() : '';

export const getErrorMessage = (error: unknown): string => {
  if (error && typeof error === 'object') {
    const { status, message } = error as { status?: number | string; message?: string };

    if (typeof message === 'string' && message) {
      return message;
    }

    if (status) {
      return status === 404 ? 'Not found (404)' : `Request failed (${status})`;
    }
  }

  return 'Request failed';
};

export const isNotFound = (error: unknown): boolean => (error as { status?: number } | null)?.status === 404;

export const loadStoredValue = (key: string): Nullable<string> => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

export const saveStoredValue = (key: string, value: string) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    /* storage may be unavailable: the page works without it */
  }
};
